import React from 'react';
import { LockIcon } from 'lucide-react';
import type { CategoryListing } from '../../types/category';
type LockedListingProps = {
  listing: CategoryListing;
};
export function LockedListing({
  listing
}: LockedListingProps) {
  return <article className="flex h-full flex-col" data-id="element-168" data-mp="11owdeejw7hah">
      <div className="relative aspect-[4/3] overflow-hidden bg-mist" data-id="element-169" data-mp="16p0t42cz87zn">
        <img src={listing.image} alt={listing.alt} className="h-full w-full scale-[1.04] object-cover blur-[2px]" data-id="element-170" data-mp="16mxw2ydepelf" />
        <div className="absolute inset-0 bg-ink/15" aria-hidden="true" data-id="element-171" data-mp="1fpyz2q6z6pkv" />
        <span className="absolute left-4 top-4 bg-paper px-3 py-1.5 text-[13px] font-medium text-ink" data-id="element-172" data-mp="1fnw2tof8c07p">{listing.kind}</span>
        <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center bg-ink/60 text-paper backdrop-blur-sm" data-id="element-173" data-mp="1pfsb1sb156pn">
          <LockIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-174" data-mp="1ufo7n6hedvv6" />
        </span>
      </div>

      <div className="flex flex-1 flex-col pt-5" data-id="element-175" data-mp="1zf148iy2mhay">
        <p className="text-[14px] font-light text-ink/65" data-id="element-176" data-mp="1zbll951a0o49">{listing.location}</p>
        <h3 className="mt-2 select-none font-editorial text-[26px] leading-[30px] text-ink blur-[6px]" aria-hidden="true" data-id="element-177" data-mp="171glwxgxw42c">
          {listing.title}
        </h3>
        <p className="sr-only" data-id="element-178" data-mp="x17nre3e08kb">Details are shared with members on introduction.</p>
        <ul className="mb-6 mt-4 flex select-none flex-wrap gap-x-4 gap-y-1 text-[14px] font-light text-ink/70 blur-[5px]" aria-hidden="true" data-id="element-179" data-mp="t0w15vrgry67">
          {listing.specs.map(s => <li key={s} data-id="element-180" data-mp="1krk49dcp7dmi">{s}</li>)}
        </ul>
        <div className="mt-auto flex items-center justify-between border-t border-line pt-4" data-id="element-181" data-mp="1ks3j2l71xlwb">
          <span className="text-[14px] font-light text-ink/65" data-id="element-182" data-mp="1fzaf3zjeqhla">Price on introduction</span>
          <span className="inline-flex items-center gap-1.5 text-[13px] font-medium text-ink" data-id="element-183" data-mp="1bygqf3y54yrc">
            <LockIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-184" data-mp="28hxvx2rdfagk" />
            Members only
          </span>
        </div>
      </div>
    </article>;
}